import { Document } from '@contentful/rich-text-types'
import React, { useState, useMemo } from 'react'
import { Heading, Icon } from '@superhi/design'

import { LibraryPostBlockBase } from '../types'
import ArticleBody from '../..'

import { Wrapper, Header, Content } from './styles'

export type LibraryPostBlockCollapsible = LibraryPostBlockBase<
  'libraryPostBlockCollapsible',
  {
    title: string
    content: Document
  }
>

type Props = {
  title: string
  content: Document
}

const LibraryPostBlockCollapsible: React.FC<Props> = ({ title, content }) => {
  const [open, setOpen] = useState(false)
  const children = useMemo(() => JSON.stringify(content), [content])

  return (
    <Wrapper>
      <Header color="BLUE_50" hoverColor="BLUE_60" onClick={() => setOpen((state) => !state)}>
        <Heading level="4" as="div">
          {title}
        </Heading>
        <Icon name={open ? 'chevron-up' : 'chevron-down'} />
      </Header>
      {open && <Content>{<ArticleBody>{children}</ArticleBody>}</Content>}
    </Wrapper>
  )
}

export default LibraryPostBlockCollapsible
